module.exports = __webpack_public_path__ + "static/media/brain.73f440d5.svg";